var menu = jQuery('.menu-item-has-children');

jQuery(menu).on('click', function(event){

	jQuery(this).toggleClass('is-active');
	if(jQuery(this).hasClass('is-active')){
		jQuery(document).on('click', function() {
			jQuery(this).removeClass('is-active');
		});
	}
});

var mobileMenu = jQuery('.nav__mobile');

mobileMenu.on('click', function(){
	jQuery(this).toggleClass('is-active');
	jQuery('.nav__menu').toggleClass('is-active');
	jQuery('html').toggleClass('menu-opened');
});